export default "__VITE_ASSET__D4T1Q7Kf__"